<template>
  <div class="">
    <ul class="tp-allshow-list" v-if="filteredItems">
      <li class="tp-show__list-item tp-allshow__list-item" v-for="item in filteredItems.items" :key="item.slug">
        <router-link
            :to="'/' + $store.state.lang + item.videoSlug">
          <div class="tp-show__list-item__thumb">
            <i class="tp-show__list-item__desc__mobtime">{{ item.dateOfBroadcast }}</i>
            <img v-if="deskImg" :src="$store.state.imgDomain + item.image" :alt="item.name">
            <img v-if="mobImg" :src="$store.state.imgDomain + item.imageMob" :alt="item.name">
            <div class="tp-show__list-item__play">
            </div>
            <div class="tp-show__list-item__check"
                 v-if="item.timeUploadVideo !== '0000-00-00 00:00:00'  &&
                      new Date() < new Date(item.timeUploadVideo.replace(/-/g, '/')) && item.plugType === 1">
              <span>Скоро</span>
              <div class="tp-show__list-item__check-bg"></div>
            </div>
            <div class="tp-show__list-item__check"
                 v-if="item.timeUploadVideo !== '0000-00-00 00:00:00'  &&
                      new Date() <= new Date(item.timeUploadVideo.replace(/-/g, '/')) && item.plugType === 2">
              <span>{{ item.plugTime.slice(0, 10).replace(/-/g, '.') }}</span>
              <div class="tp-show__list-item__check-bg"></div>
            </div>
            <span class="tp-show__list-item__time" v-if="item.duration !== 0">{{ item.duration | formatToHHmmss }}</span>
          </div>
          <div class="tp-show__list-item__desc">
            <h2>
              <i class="tp-show__list-item__desc__date">{{ item.dateOfBroadcast | replace('-','.') | truncate(10, '') | formatDate }}</i>
              <i class="tp-show__list-item__desc__title">{{ item.title }}</i>
              <i class="tp-show__list-item__desc__mobdate">{{ item.dateOfBroadcast | replace('-','.') | truncate(10, '') | formatDate }}</i>
            </h2>
          </div>
        </router-link>
      </li>
    </ul>
    <!--  SLDS_Teleportal_Footer  -->
<!--    <div class="g-tag-wrap">-->
<!--      <div id='div-gpt-ad-1629990708709-0' :bind="foot1"></div>-->
<!--    </div>-->
    <!--  SLDS_Teleportal_Footer end -->
  <foot v-if="this.filteredItems"></foot>
  </div>
</template>

<script>
import axios from "axios";
import config from "../../public/js/config";
import Foot from "@/components/footer";

export default {
  components: {
    Foot,
  },
  name: "sortedFilms",
  data() {
    return {
      deskImg: true,
      mobImg: false,
      filtered: this.$route.params.filtered,
      itemlist: [],
      filteredItems: null,
      fullPath: this.$route.fullPath,
      slug: this.$route.params.slug,
      typeSlug: this.$router.currentRoute.matched[0].path.substring(14),
      channelSlug: this.$route.params.channelSlug,
      seoTitle: this.$route.params.seoTitle,
      seoDescription: this.$route.params.seoDescription,
      seoKeywords: this.$route.params.seoKeywords,
      projectSlug: null
    }
  },
  metaInfo() {
    if (this.filteredItems) {
      if(this.channelSlug === 'stb') {
        return {
          title: this.filteredItems.channels[0].seoTitle,
          meta: [
            {
              vmid: 'description',
              name: 'description',
              content: this.filteredItems.channels[0].seoDescription
            },
            {
              name: 'keywords',
              vmid: 'keywords',
              content: this.filteredItems.channels[0].seoKeywords
            }
          ]
        }
      }
      if(this.channelSlug === 'novyy-kanal') {
        return {
          title: this.filteredItems.channels[1].seoTitle,
          meta: [
            {
              vmid: 'description',
              name: 'description',
              content: this.filteredItems.channels[1].seoDescription
            },
            {
              name: 'keywords',
              vmid: 'keywords',
              content: this.filteredItems.channels[1].seoKeywords
            }
          ]
        }
      }
      else {
        return {
          title: this.filteredItems.channels[2].seoTitle,
          meta: [
            {
              vmid: 'description',
              name: 'description',
              content: this.filteredItems.channels[2].seoDescription
            },
            {
              name: 'keywords',
              vmid: 'keywords',
              content: this.filteredItems.channels[2].seoKeywords
            }
          ]
        }
      }
    }
  },
  beforeCreate() {
    // window.googletag.cmd.push(() => {
    //   window.googletag.destroySlots();
    // });
    // this.$store.dispatch('show');
    // this.$store.dispatch('serials');
    this.$store.dispatch('films');
  },
  created() {
    this.getWinSize();
    // console.log(this.$route.params)
    // console.log(this.$router.currentRoute)
  },
  mounted() {
    // this.foot1();
    axios.get(config.VUE_APP_API_BASE_URL + this.fullPath, {})
        .then(response => (this.filteredItems = response.data))
        .catch(err => {
          if (err) {
            console.log(err)
            // window.location.href = '/' + this.$store.state.lang + '/404'
          }
        })
    // console.log(this.fullPath)
  },
  methods: {
    getWinSize() {
      if (window.visualViewport.width > 510) {
        this.deskImg = true
        this.mobImg = false
      } else if (window.visualViewport.width <= 510) {
        this.deskImg = false
        this.mobImg = true
      }
    },
    // foot1() {
    //   window.googletag.cmd.push(function () {
    //     if (window.innerWidth > 970) {
    //       window.googletag.defineSlot('/58302844/SLDS_Teleportal_Footer', [[728, 90], [970, 90]], 'div-gpt-ad-1629990708709-0').addService(window.googletag.pubads());
    //     }
    //     else {
    //       window.googletag.defineSlot('/58302844/SLDS_Teleportal_Footer', [320, 50], 'div-gpt-ad-1629990708709-0').addService(window.googletag.pubads());
    //     }
    //     window.googletag.display('div-gpt-ad-1629990708709-0');
    //   });
    // }
  },
  filters: {
    replace: function (st, rep, repWith) {
      const result = st.split(rep).join(repWith)
      return result;
    },
    truncate: function (text, length, suffix) {
      if (text.length > length) {
        return text.substring(0, length) + suffix;
      } else {
        return text;
      }
    },
    formatDate: function (value) {
      let dArr = value.split(".");
      return dArr[2] + "." + dArr[1] + "." + dArr[0];
    },
    formatToHHmmss: function (val) {
      let milliseconds = val
      let seconds = parseInt((milliseconds / 1000) % 60),
          minutes = parseInt((milliseconds / (1000 * 60)) % 60),
          hours = parseInt((milliseconds / (1000 * 60 * 60)) % 24);

      hours = (hours < 10) ? "0" + hours : hours;
      minutes = (minutes < 10) ? "0" + minutes : minutes;
      seconds = (seconds < 10) ? "0" + seconds : seconds;

      return hours + ":" + minutes + ":" + seconds;
    }
  },
  watch:{

  },

  computed: {

  },
}
</script>

<style scoped>
.tp-show__list-item__thumb_large {
  display: block !important;
  height: 135px;
  padding-top: 0 !important;
}

.tp-show__list-item__desc__title {
  font-weight: normal;
  border-right: none;
  padding: 0 0 0 5px;
}
</style>
